import { CardTitle } from '@/components/Shares/CardTitle';
import { CarouselLayout } from '@/components/Shares/CarouselLayout';
import { useLingui } from '@lingui/react';
import { Carousel } from '@mantine/carousel';
import { Box } from '@mantine/core';
import { BiggestCard } from './BiggestCard';
import { biggest } from './data';
export const BiggestGames: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Box mt={20} maw={{
    md: '62em',
    lg: '75em',
    xl: '88em'
  }}>
      <CarouselLayout id="biggest-stats" items={biggest} isShadow title={<CardTitle firstText={i18n._('Biggest Wins')} isFirstGradient colorFrom="#DBFE02" colorTo="#44FF66" iconUrl="/assets/title-icons/1.png" mt={6} />} slideSize={{
      base: '40%',
      sm: '22%',
      md: '20%',
      xl: '13.33%'
    }}>
        {biggest.map(item => <Carousel.Slide key={item.id}>
            <BiggestCard {...item} />
          </Carousel.Slide>)}
      </CarouselLayout>
    </Box>;
};